module.exports = __webpack_public_path__ + "img/total_drivers.455a8177.svg";